import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionRadioComponent } from './question-radio.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@NgModule({
  imports: [
    QuestionModule,
    NgxChartsModule,
  ],
  declarations:[QuestionRadioComponent],
  exports:[QuestionRadioComponent],
})
export class QuestionRadioModule { }

